<template>
    <div class="bd">
        <header_top :in_dialog="in_dialog"></header_top>
        <div class="bd-body">
            <div class="bd-grid">
                <div class="bd-main">
                    <passengers></passengers>
                    <booking_notes></booking_notes>
                    <booking_documentation></booking_documentation>
                </div>
                <booking_details :in_dialog="in_dialog" @booking_cancelled="Relay_Cancelled"></booking_details>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./details_content.ts"></script>
